import React from "react";

const NewBusinessForm = ({ nextStep, setFormData, formData, onSubmit }) => {
  const handleSubmit = () => {
    if (!formData.business_name) {
      alert("Please enter a name for your business.");
      return;
    }

    // Automatically set the start date and submit the form data
    onSubmit({
      ...formData,
      business_start_date: new Date().toISOString(), // Fixed key to match `formData` structure
    });
    nextStep();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold">What are you thinking of calling your business?</h2>
      <p className="text-gray-600 mt-2">(You can change this later.)</p>
      <div className="mt-6">
        <input
          type="text"
          placeholder="Enter business name"
          name="business_name"
          value={formData.business_name || ""}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <button
        className="mt-6 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200"
        onClick={handleSubmit}
      >
        Save and Continue
      </button>
    </div>
  );
};

export default NewBusinessForm;